import { render } from "./CurrencyAdvanced.vue?vue&type=template&id=2199f3e8"
import script from "./CurrencyAdvanced.vue?vue&type=script&lang=js"
export * from "./CurrencyAdvanced.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__